import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { OrderResponse } from '../../types/order';
import BonusNotice from './BonusNotice';
interface OrderConfirmationProps {
  order: OrderResponse;
}

function OrderConfirmation({ order }: OrderConfirmationProps) {
  return (
    <Box sx={{ py: 4, minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={3} sx={{ p: 6, maxWidth: 600, textAlign: 'center' }}>
        <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        
        <Typography variant="h4" gutterBottom>
          Order Confirmed!
        </Typography>
        
        <Typography variant="h6" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
          Order Reference: {order.order_reference}
        </Typography>
        
        <Alert severity="success" sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="body1" gutterBottom>
            <strong>Thank you for your order!</strong>
          </Typography>
          <Typography variant="body2">
            We have received your order for internet services at {order.service_address}.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Our team will process your order and contact you shortly with next steps.
          </Typography>
        </Alert>
        
        {order.coupon_bonus_title && (
          <Box sx={{ mb: 3 }}>
            <BonusNotice
              title={order.coupon_bonus_title}
              description={order.coupon_bonus_description}
              terms={order.coupon_bonus_terms}
            />
          </Box>
        )}

        <Box sx={{ mt: 4 }}>
          <Typography variant="body2" color="text.secondary">
            A confirmation email has been sent to {order.email}. If you don't receive it within a few minutes, please check your spam folder or contact us with your reference {order.order_reference}.
          </Typography>
        </Box>
        
        <Button
          variant="contained"
          sx={{ mt: 4 }}
          href="https://sonicnet.net.au/"
        >
          Return to Home
        </Button>
      </Paper>
    </Box>
  );
}

export default OrderConfirmation;

